import { useMemo, useState, useEffect } from "react";
import { RevTabs } from "@revmatics/catalyst";
import { BrandGuidelinesDosAndDontsView } from "./dosAndDonts/BrandGuidelinesDosAndDontsView.tsx";
import { BrandGuidelinesBrandSafetyView } from "./brandSafety/BrandGuidelinesBrandSafetyView.tsx";
import { brandGuidelinesTabsData } from "../../../brandDetailsData.ts";
import { useParams } from "react-router";
import { switchActiveTab } from "../../../../../helpers/functions/switchActiveTab.tsx";

type Props = {
  initialTab: string | null;
  readAccessOnly: boolean;
};

export const BrandGuidelinesView = ({ initialTab, readAccessOnly }: Props) => {
  const [activeTab, setActiveTab] = useState("dos_and_donts");
  const { brandId } = useParams();

  // Navigates to the tab specified in a query parameter
  useEffect(() => {
    switchActiveTab(initialTab, brandGuidelinesTabsData, setActiveTab);
  }, [initialTab]);

  const content = useMemo(() => {
    switch (activeTab) {
      case "dos_and_donts":
        return (
          <BrandGuidelinesDosAndDontsView readAccessOnly={readAccessOnly} />
        );
      case "brand_safety":
        return (
          <BrandGuidelinesBrandSafetyView readAccessOnly={readAccessOnly} />
        );
      default:
        return null;
    }
  }, [activeTab, readAccessOnly]);

  return (
    <div className="space-y-4">
      <RevTabs
        size="small"
        data={brandGuidelinesTabsData}
        tabId={`brand-guidelines-tab-${brandId}`}
        selected={activeTab}
        handleSelect={(value: string) => setActiveTab(value)}
      />
      {content}
    </div>
  );
};
